<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #DETAILS="{visible,params}">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
  </cTable>
</template>

<script>
import { getList, add } from "@/api/order/returnRefund";
import { getOrderDetails } from "@/api/order/list";
import Tracker from "@/base/order_tracker";
import { getAllClient } from "@/api/user/client";
import { getAgent } from "@/api/tracker/agent";
import { getSelectType } from "@/api/public";
import { getCurrency } from "@/api/finance/currency";
import { getUser } from "@/api/user/internal";
import cTable from "@/base/common/index";
export default {
  name: "returnRefund",
  components: {
    cTable,
    Tracker
  },
  async created() {
    let deliver = (
      await getAgent({
        agent_type: "bag",
        status: "YES",
        types: "DELIVERY"
      })
    ).data.payload.rows;
    let client = (await getAllClient()).data.payload.rows;
    let reason = (await getSelectType("REFUNDS_REASON")).data.payload[
      "REFUNDS_REASON"
    ];
    let source = (await getSelectType("REFUNDS_SOURCE")).data.payload[
      "REFUNDS_SOURCE"
    ];
    let currency = (await getCurrency({ pageSize: 100 })).data.payload.rows;
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id") item.options = client;
      if (item.key === "deliver") item.options = deliver;
      if (item.key === "reason") item.options = reason;
      if (item.key === "source") item.options = source;
      if (item.key === "customer_service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
    });
    this.modals["addReturn"]["fields"].forEach(async item => {
      if (item.key === "reason") item.options = reason;
      if (item.key === "currency") item.options = currency;
    });
  },
  data() {
    return {
      amount: 0,
      methods: {
        list: getList,
        add,
        getAllClient
        // getDetails
      },
      config: {
        height: 630
      },
      modals: {
        addReturn: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("add", row, true).then(res => {
                this.$page.getList();
                this.close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ],
              reason: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              amount: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr",
                  type: "number"
                }
              ],
              // currency: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "change"
              //   }
              // ]
              cod_remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 140
            },
            title: this.$t("add") + this.$t("returnRefund"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [
            { airway_number: 24 },
            { reason: 24 },
            { amount: 24 },
            // { currency: 24 },
            { cod_remarks: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              },
              methods: {
                "on-blur": ({ value, formData }) => {
                  if (!value) return;
                  getOrderDetails(value).then(res => {
                    formData["amount"] = Number(res.data.payload.cod_amount);
                    this.amount = Number(res.data.payload.cod_amount);
                  });
                }
              }
            },
            {
              key: "reason",
              name: () => this.$t("returnRefund") + this.$t("reason"),
              component: "Select",
              options: [],
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("returnRefund") +
                  this.$t("order_desc")
                );
              }
            },
            {
              key: "amount",
              name: () => this.$t("refund") + this.$t("amount"),
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: 0,
              placeholder() {
                return this.$t("enter") + this.$t("refund") + this.$t("amount");
              }
            },
            // {
            //   key: "currency",
            //   name: () => this.$t("refund") + this.$t("currency_t"),
            //   component: "Select",
            //   options: [],
            //   config: {
            //     label: "code",
            //     value: "code"
            //   },
            //   placeholder() {
            //     return (
            //       this.$t("select") + this.$t("refund") + this.$t("currency_t")
            //     );
            //   }
            // },
            {
              key: "cod_remarks",
              name: () =>
                this.$t("modify") +
                this.$t("refund") +
                this.$t("reChAmount") +
                this.$t("order_desc"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              show: ({ row }) => row["amount"] != this.amount,
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("modify") +
                  this.$t("refund") +
                  this.$t("reChAmount") +
                  this.$t("order_desc")
                );
              }
            },
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              }
            }
          ]
        },
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            }
          },
          footer: { show: () => false }
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              }
            }
          },
          {
            key: "customer_service_id",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "client_id",
            component: "Select",
            bind: {
              style: "width:175px"
            },
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "deliver",
            component: "Select",
            bind: {
              style: "width:175px"
            },
            placeholder() {
              return this.$t("select") + this.$t("localFaction");
            },
            options: [],
            config: {
              label: "agent_name",
              value: "agent_name"
            }
          },
          {
            key: "source",
            component: "Select",
            bind: {
              style: "width:175px"
            },
            placeholder() {
              return this.$t("select") + this.$t("source");
            },
            options: []
          },
          {
            key: "reason",
            component: "Select",
            bind: {
              style: "width:175px"
            },
            placeholder() {
              return this.$t("select") + this.$t("reason");
            },
            options: []
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add") + this.$t("returnRefund"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            addFun() {
              this.getModal("addReturn").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          component: "Button",
          copy: true,
          align: "center",
          fixed: "left",
          bind: {
            type: "primary",
            size: "small"
          },
          showOverflow: false,
          width: 160,
          methods: {
            click({ row }) {
              this.$page.getModal("show").setTitle(row.airway_number);
              this.$page.getModal("show").open({ row });
            }
          }
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 95
        },
        {
          name: () => this.$t("Company name"),
          key: "shipper_company_cn",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("pod_time1"),
          key: "pod_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("localFaction"),
          key: "deliver",
          align: "center",
          minWidth: 120
        },
				{
				  name: () => this.$t("country_t"),
				  key: "to_country",
				  align: "center",
				  minWidth: 120
				},
        {
          name: () => this.$t("Refund Reason"),
          key: "reason",
          align: "center",
          minWidth: 120
        },

        {
          name: () => this.$t("Refound Amount"),
          key: "amount",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$t("Refound Currency"),
          key: "currency",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("codAmount"),
          key: "cod_amount",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("source"),
          key: "source",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "service_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 130,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        }
        // {
        //   type: "btns",
        //   width: 100,
        //   name: () => this.$t("operation"),
        //   fixed: "right",
        //   list: [
        //     {
        //       name: () => this.$t("operation"),
        //       type: "operation",
        //       fnName: "operationFun",
        //       bind: {
        //         type: "warning"
        //       }
        //     }
        //   ],

        //   methods: {
        //     operationFun({ row }) {
        //       this.getModal("operation").open({ id: row.airway_number });
        //     }
        //   }
        // }
      ]
    };
  }
};
</script>
